module.exports = __webpack_public_path__ + "b1b0c91eaf6d8501789509826f83bad0.svg";